export default "__VITE_ASSET__CGaU4I8E__"